import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SignInChoice.css';

const SignInChoice = () => {
  const navigate = useNavigate();

  return (
    <div className="signin-choice-container">
      <div className="signin-choice-card">
        <h1 className="signin-choice-title">Sign in to CityLink</h1>
        <p className="signin-choice-subtitle">
          Choose how you want to sign in.
        </p>
        <div className="signin-choice-grid">
          <button
            className="signin-choice-option resident"
            onClick={() => navigate('/login')}
          >
            <span className="signin-choice-option-label">Resident / Requester</span>
            <span className="signin-choice-option-desc">
              Apply for permits or report issues as a member of the public.
            </span>
          </button>
          <button
            className="signin-choice-option staff"
            onClick={() => navigate('/staff-login')}
          >
            <span className="signin-choice-option-label">City staff</span>
            <span className="signin-choice-option-desc">
              Review and manage permits or code enforcement as a staff member.
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignInChoice;

